'use client'

export type GlobalErrorPageProps = {
  error?: Error
  title?: string
  message?: string
}

export function GlobalErrorPage({
  error,
  title = 'Application Error',
  message = 'An unexpected error occurred. Please refresh the page.',
}: GlobalErrorPageProps) {
  return (
    <html lang="en">
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen bg-background-default">
          <h1 className="text-4xl font-bold mb-4 text-foreground-default">{title}</h1>
          <p className="mb-8 text-foreground-muted">{message}</p>
          {error && (
            <details className="mt-4 text-sm text-foreground-muted">
              <summary className="cursor-pointer">Error details</summary>
              <pre className="mt-2 p-4 bg-border-muted rounded" style={{ maxWidth: '600px', overflow: 'auto' }}>
                {(error instanceof Error ? error.message : String(error))}
                {error.stack && `\n\n${error.stack}`}
              </pre>
            </details>
          )}
        </div>
      </body>
    </html>
  )
}

